import axiosInstance from "./axiosInstance";

export const getWalletDetail = async () => {
  try {
    const response = await axiosInstance.get(`/ads/wallet`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// 获取支付地址
export const getPaymentUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(`/ads/payment/checkout`, params);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const checkPaymentRetrieve = async (params: any) => {
  const { sessionId } = params || {};
  try {
    const response = await axiosInstance.get(
      `/ads/payment/checkout/retrieve?session_id=${sessionId}`
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const savePaymentMethod = async (params: any) => {
  try {
    const response = await axiosInstance.post(`/ads/payment/method`, params);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// checkout
export const checkoutApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/checkout`
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// 获取创建订阅支付地址
export const getCreateSubscribeUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/payment/subscription`,
      params
    );
    return response.data.data;
  } catch (error) {
    return error;
  }
};

// 获取更新订阅支付地址
export const getUpdateSubscribeUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/payment/subscription/update`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error?.message;
  }
};

// 获取取消订阅支付地址
export const getCancelSubscribeUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/payment/subscription/cancel`,
      params
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// 查询发票列表
export const getInvoicesListUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/wallet/getInvoices`,
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 查询充值列表
export const getDepositListUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/wallet/deposits`,
      params,
      { responseType: params.isDownload ? "blob" : undefined }
    );
    return params.isDownload ? response : response.data;
  } catch (error) {
    throw error;
  }
};

// 更新钱包账单信息
export const upDataBillingInfoUrl = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/wallet/billingInfo`,
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 获取 大客户方案价格 & cold email 价格
export const getEnterprisePlanPriceApi = async (
  campaignId: string,
) => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/${campaignId}/chargeDetail`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 获取cold email 价格
export const chargeDetailApi = async (
  campaignId: string,
  amount?: number,
  leadId?: string
) => {
  let ApiUrl = `/ads/campaign/${campaignId}/chargeDetail/leads`;
  if (amount)
    ApiUrl = `/ads/campaign/${campaignId}/chargeDetail/leads?amount=${amount}`;
  if (leadId) ApiUrl = `/ads/campaign/${campaignId}/chargeDetail/leads?id=${leadId}`;
  try {
    const response = await axiosInstance.get(ApiUrl);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// cold email 支付
export const infraApi = async (
  campaignId: string,
  amount?: number,
  leadId?: string
) => {
  let ApiUrl = `/ads/campaign/${campaignId}/infra`;
  let params = {};
  if (amount) {
    ApiUrl = `/ads/campaign/${campaignId}/addLeads`;
    params = {
      amount: amount,
    };
  }
  if (leadId) {
    ApiUrl = `/ads/campaign/${campaignId}/unlock`;
    params = {
      leadId: leadId,
    };
  }
  try {
    const response = await axiosInstance.post(ApiUrl, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// cold Email 支付状态查询

export const getTransactionStatusApi = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/ads/payment/transaction/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// 获取chatbot credits 明细

export const getHeadCreditsDetailApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/wallet/transactions/head`,
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 下载账单详情
export const walletBillDownloadApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/wallet/bill/download`,
      params,
      { responseType: "blob" }
    );
    return response;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
